import React, { useContext } from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames/bind';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  bool as boolType,
  shape,
  string as stringType,
  arrayOf,
  params, useDataModel, extend
} from '@thd-nucleus/data-sources';
import {
  Card,
  CardContent,
  CardTitle,
  Carousel,
  Col,
  Row
} from '@thd-olt-component-react/core-ui';
import { StorePod, StorePodServices } from '@thd-olt-component-react/store-pod';
import { StoreHeroContext } from '../../StoreHero.context';
import { FeaturesList } from './features-list/FeaturesList';
import styles from './store-hero-features.module.scss';

const cx = classNames.bind(styles);

const StoreHeroFeatures = ({ className, showServices }) => {
  const { loading, store } = useContext(StoreHeroContext);

  const slides = [
    <FeaturesList key="FeaturesListSlide" />,
    <StorePod key="StorePodSlide" loading={loading} store={store}>
      <StorePodServices disablePlaceholder showIcon />
    </StorePod>
  ];

  if (showServices) {
    return (
      <Card className={cx(className, 'store-hero-features')} sharp>
        <CardTitle title="Store Features" />
        <CardContent>
          <Row>
            <Col nopadding>
              <Carousel
                dotsBelow
                pagination
                peek={false}
                slidesPerView={1}
              >
                {slides}
              </Carousel>
            </Col>
          </Row>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={cx(className, 'store-hero-features')} sharp elevation={2}>
      <CardTitle title="Store Features" />
      <CardContent>
        <FeaturesList />
      </CardContent>
    </Card>
  );
};

StoreHeroFeatures.propTypes = {
  className: string,
  showServices: bool
};

StoreHeroFeatures.defaultProps = {
  className: null,
  showServices: false
};

StoreHeroFeatures.displayName = 'StoreHeroFeatures';

StoreHeroFeatures.dataModel = extend({
  seoStoreRentals: params({ storeId: stringType().isRequired() }).shape({
    programs: shape({
      toolsAndTrucks: boolType(),
      noShow: boolType(),
      onlyTools: boolType(),
      onlyTrucks: boolType(),
      justMoving: boolType()
    }),
    rentals: arrayOf(shape({
      category: stringType()
    }))
  })
});

export { StoreHeroFeatures };
